<template>
    <div id="app">
        <div v-if="!isOnline" class="offline">
            <h3>You are Offline.</h3>
            <p>Offline mode is not yet supported, but coming soon!</p>
        </div>
        <div v-if="requirePin" class="content align-center">
            <form v-on:submit.prevent="enterPin">
                <div class="field">
                    <label>What's your PIN?</label>
                    <br>
                    <br>
                    <input type="tel" v-model="newPin" class="pin" placeholder="****" maxlength="4" autofocus>

                    <span class="pin-error notice red">
                        <span v-if="pinError">{{pinError}}</span>
                    </span>
                </div>

                <div class="field">
                    <button type="submit">
                        Enter PIN
                    </button>
                </div>
            </form>

            <p class="align-center logout">
                <a href="javascript:;" v-on:click="app.logout()" class="hint">
                    Reset Data on this Device
                </a>
            </p>

            <Footer />
        </div>
        <div v-else>
            <div v-if="loading" class="loading content align-center">
                <p>Loading...</p>
            </div>

            <router-view v-else :app="app" />

            <Footer />
        </div>
    </div>
</template>

<style lang="scss">
@import "./index.scss";
</style>

<script>
if (process.env.NODE_ENV === 'production') {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('./sw.js');
        });
    }
} else {
    window.API_URL = 'http://localhost:8888/attend/wp-json/attendance/v1';
}

function uniques(value, index, self) {
    return self.indexOf(value) === index;
}

import Vue           from 'vue';
import async         from 'async';
import localForage   from 'localforage';
import uniqId        from 'uniq-id';
import xhr           from '@/components/app/ajax';
import seed          from '@/components/app/seed';
import Footer        from '@/components/footer/component.vue';
import { saveAs }    from 'file-saver';

var POLL = 15000,
    generateId = uniqId.generateUUID('xxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxyxxxxy', 32),
    LINKED_ATTRIBUTES = {
        locations: ['peopleIds'],
        people: [],
        days: ['locationId', 'peopleIds'],
        staff: []
    },
    SPLIT_NAME = /\s+?/,
    POLLING, POLLER;

function singularize(type) {
    if (type === 'people') {
        return 'person';
    }

    if (type === 'staff') {
        return 'staff';
    }

    return type.slice(0, -1);
}

export default {
    components: {
        Footer
    },
    data() {
        var _ = this;

        window.app = _;

        return {
            app: _,
            logo: window.logo || '/img/logo.svg',
            loading: true,
            user: { permissions: [] },
            requirePin: undefined,
            isAddingLocation: false,
            newPin: '',
            pinError: undefined,
            pin: undefined,
            hints: {},
            locations: [],
            people: [],
            days: [],
            staff: [],
            unsaved: [],
            isPaid: window.SECRET_KEY ? window.SECRET_KEY[0] === 'p' : false,
            isOnline: window.navigator.onLine,
            api: false,
            store: localForage.createInstance({
                name: 'attend'
            })
        };
    },
    mounted() {
        var _ = this;

        if (!window.API_URL) {
            alert('Invalid link for Attendance. Please visit the URL in your WordPress dashboard at Settings > Attendance.');
            return;
        }

        _.fetchPin(function() {
            _.applyHints(function() {
                _.saveUnsavedRemote(function() {
                    _.fetch(function() {
                        // _.applySeed(function() {
                            _.saveLocal(function() {
                                _.loading = false;

                                POLLER = setTimeout(function() {
                                    _.poll();
                                }, POLL);
                            });
                        // });
                    });
                });
            });
        });

        window.addEventListener('online',  function() {
            _.isOnline = true;
            _.poll();
        });

        window.addEventListener('offline',  function() {
            _.isOnline = false;
        });

        // window.addEventListener('focus', function() {
        //     _.poll();
        // });
    },
    computed: {
        selectedLocation() {
          var _ = this;

          return _.sortedLocations.find(function(location) {
              return location.id + '' === _.$route.params.id + '';
          });
        },
        sortedLocations() {
            var _ = this;

            return _.locations.filter(function(item) {
                return item._status === 'publish';
            }).sort(_.sortByName);
        },
        sortedPeople() {
            var _ = this;

            return _.people.filter(function(item) {
                return item._status === 'publish';
            }).sort(_.app.sortByPersonName);
        },
        sortedDays() {
            var _ = this;

            return _.days.filter(function(item) {
                return item._status === 'publish';
            }).sort(_.app.sortById);
        },
        sortedStaff() {
            var _ = this;

            return _.staff.filter(function(item) {
                return item._status === 'publish';
            }).sort(_.app.sortById);
        }
    },
    watch: {
        newPin() {
            this.pinError = undefined;
        }
    },
    methods: {
        generatePin: uniqId.generateUUID('xxxx', 10),

        resetPin() {
            var _ = this;

            _.pin = undefined;
            _.store.removeItem('pin');
        },

        fetchPin(done) {
            var _ = this;

            _.store.getItem('pin', function(err, value) {
                if (value) {
                    _.pin = value;
                }

                done();
            });
        },

        enterPin() {
            var _ = this;

            _.loading = true;

            xhr({
                method: 'POST',
                url: window.API_URL + '/' + _.newPin + '/pin',
                data: { pin: _.newPin },
                beforeSend(a) {
                    a.setRequestHeader('Authorization', 'Basic ' + btoa(_.newPin));
                },
                success() {
                    _.loading = false;

                    _.pin = _.newPin;
                    _.newPin = '';
                    _.store.setItem('pin', _.pin);

                    if (typeof _.requirePin === 'function') {
                        _.requirePin.call(_);
                    }

                    _.requirePin = undefined;
                },
                error() {
                    _.pinError = 'Invalid PIN.';
                    _.loading = false;
                },
            });
        },

        hideHint(type) {
            var _ = this;
            Vue.set(_.hints, type, true);
            _.store.setItem('hint-' + type, true);
        },

        poll() {
            var _ = this;

            if (POLLING) return;

            POLLING = true;

            clearTimeout(POLLER);

            _.saveUnsavedRemote(function() {
                _.fetchRemote(function() {
                    _.afterFetchItems(function() {
                        POLLING = false;

                        POLLER = setTimeout(function() {
                            _.poll();
                        }, POLL);
                    });
                });
            });
        },

        applySeed(done) {
            var _ = this;

            if (_.locations.length || _.people.length) {
                return done();
            }

            _.locations = seed.locations;
            _.people = seed.people;
            _.days = seed.days;
            _.staff = seed.staff;

            done();
        },

        merge(a, b) {
            if (typeof b !== 'object') return;

            var item, key;

            for (var i = b.length - 1; i >= 0; i--) {
                item = a.find(function(c) {
                    return c.id + '' === b[i].id + '';
                });

                if (item) {
                    for (key in b[i]) {
                        item[key] = b[i][key];
                    }
                } else {
                    a.push(b[i]);
                }
            }
        },

        permittedLocations(user) {
            var _ = this;

            return _.sortedLocations.filter(function(location) {
                return _.isPermitted(user.permissions, location.id);
            });
        },

        fetchLocal(done) {
            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff', 'unsaved'], function(collection, next) {
                _.store.getItem(collection, function(err, value) {
                    _.merge(_[collection], value || []);
                    next();
                });
            }, function() {
                done();
            });
        },

        fetchRemote(done) {
            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                _.ajax('GET', '/' + collection, function(err, value) {
                    _.merge(_[collection], value || []);
                    next();
                });
            }, function() {
                done();
            });
        },

        buildItem(collection, item) {
            item.id = item.id || generateId();
            item._collection = item._collection || collection;
            item._status = item._status || 'publish';

            return item;
        },

        fetch(done) {
            var _ = this;

            _.fetchLocal(function() {
                _.fetchRemote(function() {
                    _.afterFetchItems(function() {
                        done();
                    });
                });
            });
        },

        afterFetchItems(done) {
            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                var arr = _[collection];

                for (var i = arr.length - 1; i >= 0; i--) {
                    _.buildItem(collection, arr[i]);
                    arr[i]._lastUpdatedAt = arr[i].updatedAt;
                }

                next();
            }, function() {
                done();
            });
        },

        addUnsaved(unsaved) {
            var _ = this,
                existing = _.unsaved.find(function(i) {
                    return i.item && (i.item.id + '' === unsaved.item.id + '' || i.item.slug + '' === unsaved.item.id + '');
                });

            if (existing) {
                for (var key in unsaved.data) {
                    existing.data[key] = unsaved.data[key];
                }
            } else {
                _.unsaved.push(unsaved);
            }

            _.saveUnsavedLocal();
        },

        setUser(user) {
            var _ = this;

            for (var key in user) {
                _.user[key] = user[key];
            }
        },

        ajax(method, url, data, item, done) {
            if (typeof data === 'function') {
                done = data;
                data = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            var _ = this;

            _.confirmPin(function() {
                xhr({
                    method: method,
                    url: window.API_URL + '/' + _.pin + url,
                    data: data,
                    beforeSend(a) {
                        a.setRequestHeader('Authorization', 'Basic ' + btoa(_.pin));
                    },
                    success(data, xhr) {
                        var user = xhr.getResponseHeader('x-current-user');

                        _.loading = false;

                        if (item && data && (!_.isPersisted(item) || !item._isSaving)) {
                            _.merge([item], [data]);
                            _.swapIds(item, data);
                        }

                        try {
                            _.setUser(JSON.parse(user));
                        } catch (e) { }

                        if (typeof done === 'function') {
                            done(undefined, data);
                        }
                    },
                    error(err) {
                        _.loading = false;

                        if (err) {
                            if (method !== 'GET') {
                                _.addUnsaved({
                                    method: method,
                                    url: url,
                                    data: JSON.parse(JSON.stringify(data)),
                                    item: item ? {
                                        _collection: item._collection,
                                        id: item.id
                                    } : undefined
                                });
                            }

                            if (err.status > 200) {
                                console.error(err);

                                if (err.status === 401) {
                                    _.resetPin();

                                    _.confirmPin(function() {
                                        _.ajax(method, url, data, item, function() {
                                            done();
                                            _.poll();
                                        });
                                    });

                                    return;
                                }
                            }
                        }

                        if (typeof done === 'function') {
                            done(err);
                        }
                    }
                });
            });
        },

        applyHints(done) {
            var _ = this;

            async.eachSeries(['lock'], function(type, next) {
                _.store.getItem('hint-' + type, function(err, value) {
                    Vue.set(_.hints, type, !!value);
                    next();
                });
            }, function() {
                done();
            });
        },

        confirmPin(done) {
            var _ = this;

            if (!_.pin) {
                _.requirePin = done;
            } else {
                if (typeof done === 'function') {
                    done();
                }
            }
        },

        save(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            if (typeof item === 'object') {
                item._lastUpdatedAt = Math.round(Date.now() / 1000);
            }

            item._isSaving = true;

            var _ = this;

            _.saveLocal(item, attr, function() {
                _.saveRemote(item, attr, function(err, data) {
                    item._isSaving = false;

                    if (typeof done === 'function') {
                        done(err, data);
                    }
                });
            });
        },

        isPersisted(item) {
            return typeof item === 'object' && (item.id + '').length < 16;
            // (
            //     !item._lastUpdatedAt || (
            //         item.updatedAt &&
            //         item.updatedAt >= item._lastUpdatedAt
            //     )
            // );
        },

        saveUnsavedRemote(done) {
            var _ = this,
                unsaved = _.unsaved.shift();

            if (!unsaved) {
                return done();
            }

            _.saveUnsavedLocal();

            if (unsaved.item) {
                unsaved.item = _[unsaved.item._collection].find(function(i) {
                    return i.id + '' === unsaved.item.id + '' || i.slug + '' === unsaved.item.id + '';
                });

                if (unsaved.data[singularize(unsaved.item._collection)].id) {
                    unsaved.data[singularize(unsaved.item._collection)].id = unsaved.item.id;
                }
            }

            _.ajax(unsaved.method, unsaved.url, unsaved.data, unsaved.item, function(err) {
                if (err) return done();
                _.saveUnsavedRemote(done);
            });
        },

        saveUnsavedLocal(done) {
            var _ = this;
            _.store.setItem('unsaved', _.unsaved, done);
        },

        saveLocal(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            var _ = this;

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                _.store.setItem(collection, _[collection].filter(function(item) {
                    return item._status !== 'attendance-archive';
                }), function() {
                    next();
                });
            }, function() {
                if (typeof done === 'function') {
                    done();
                }
            });
        },

        saveRemote(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            if (typeof item === 'function') {
                done = item;
                item = undefined;
            }

            var _ = this;

            if (typeof item === 'object') {
                _.saveRemoteItem(item, attr, done);
                return;
            }

            async.eachSeries(['locations', 'people', 'days', 'staff'], function(collection, next) {
                async.eachSeries(_[collection], function(location, n) {
                    _.saveRemoteItem(location, n);
                }, function() {
                    next();
                });
            }, function() {
                if (typeof done === 'function') {
                    done();
                }
            });
        },

        saveRemoteItem(item, attr, done) {
            if (typeof attr === 'function') {
                done = attr;
                attr = undefined;
            }

            var _ = this,
                args = {};

            if (attr) {
                args[singularize(item._collection)] = {};
                args[singularize(item._collection)].id = item.id;
                args[singularize(item._collection)][attr] = item[attr];
            } else {
                args[singularize(item._collection)] = item;
            }

            _.ajax('POST', '/' + item._collection, args, item, function(err, value) {
                if (typeof done === 'function') {
                    done(err, value);
                }
            });
        },

        swapIds(local, remote) {
            if (remote && local.id !== remote.id) {
                var _ = this,
                    oldId = local.id,
                    single = singularize(local._collection),
                    key;

                if (_[local._collection].find(function(item) {
                    return item.id === remote.id;
                })) {
                    _[local._collection].splice(_[local._collection].indexOf(local), 1);
                    return;
                }

                local.id = remote.id;

                for (key in LINKED_ATTRIBUTES) {
                    var attr = local._collection + 'Ids';

                    if (LINKED_ATTRIBUTES[key].indexOf(attr) !== -1) {
                        _[key].forEach(function(item) {
                            var index = item[attr].indexOf(oldId);

                            if (index !== -1) {
                                item[attr][index] = remote.id;
                                _.saveRemoteItem(item);
                            }
                        });
                    }

                    attr = single + 'Id';

                    if (LINKED_ATTRIBUTES[key].indexOf(attr) !== -1) {
                        _[key].filter(function(item) {
                            if (item[attr] === oldId) {
                                item[attr] = remote.id;
                                _.saveRemoteItem(item);
                            }
                        });
                    }
                }
            }
        },

        addPersonByName(location, name, date, component) {
            var _ = this,
                person = _.buildItem('people', {
                    name: name
                });

            _.people.push(person);

            if (component) {
                component.q = '';
            }

            _.save(person, function() {
                location.peopleIds.push(person.id);
                _.save(location, function() {
                    if (date) {
                        _.present(location, person, date);
                    }
                });
            });
        },

        prepDate(date) {
            var _ = this;

            if (date instanceof Date) {
                return date.getFullYear() + '-' + _.zeroPad(date.getMonth() + 1) + '-' + _.zeroPad(date.getDate());
            }

            return date;
        },

        formatDate(date) {
            var splat = date.toDateString().split(' ');
            return splat[1] + ' ' + splat[2];
        },

        isPresent(location, person, d) {
            var _ = this;

            if (location instanceof Array) {
                for (var i = location.length - 1; i >= 0; i--) {
                    if (_.isPresent(location[i], person, d)) {
                        return true;
                    }
                }

                return false;
            } else {
                var day = _.findDay(location, d);
                return day && day.peopleIds instanceof Array && day.peopleIds.indexOf(person.id) !== -1;
            }
        },

        findDay(location, d) {
            var _ = this,
                date = _.prepDate(d),
                day = _.sortedDays.find(function(day) {
                    return day.date === date && day.locationId === location.id;
                });

            if (!day) {
                day = _.buildItem('days', {
                    name: [location.id, date].join(','),
                    date: date,
                    locationId: location.id,
                    peopleIds: []
                });

                _.days.push(day);
            }

            return day;
        },

        ensurePersisted(item, done) {
            var _ = this;

            if (_.isPersisted(item)) {
                return done();
            }

            _.save(item, done);
        },

        present(location, person, d) {
            var _ = this,
                date = _.prepDate(d),
                day = _.findDay(location, d),
                present = _.isPresent(location, person, date);

            day.peopleIds = day.peopleIds || [];

            if (present) {
                day.peopleIds.splice(day.peopleIds.indexOf(person.id), 1);
            } else {
                day.peopleIds.push(person.id);
            }

            _.saveLocal();

            _.ensurePersisted(day, function() {
                var args = {
                        item: {
                            type: 'day',
                            id: day.id
                        },
                        delta: {
                            attr: 'peopleIds',
                            value: person.id
                        }
                    };

                if (present) {
                    args.delta.action = 'remove';
                } else {
                    args.delta.action = 'add';
                }

                _.ajax('POST', '/delta', args); // , day
            });
        },

        addLocation() {
            var _ = this,
                id = _.locations.length + 1,
                location = _.buildItem('locations', {
                    name: 'Location ' + id,
                    peopleIds: []
                });

            _.isAddingLocation = true;
            _.locations.push(location);

            _.save(location, function() {
                _.isAddingLocation = false;
                _.$router.push({ name: 'locationEdit', params: { id: location.id } });
            });
        },
        addStaff() {
            var _ = this,
                id = _.staff.length + 1,
                member = _.buildItem('staff', {
                    name: 'Staff ' + id,
                    pin: _.generatePin()
                });

            _.staff.push(member);
            _.save(member);
        },
        isPermitted(staff, locationId) {
            var arr;

            if (staff instanceof Array) {
                arr = staff;
            } else {
                staff.permissions = staff.permissions || [];
                arr = staff.permissions;
            }

            return arr.indexOf('admin') !== -1 || arr.indexOf(locationId) !== -1;
        },
        togglePermissions(staff, locationId) {
            var _ = this;

            if (_.isPermitted(staff, locationId)) {
                staff.permissions.splice(staff.permissions.indexOf(locationId), 1);
            } else {
                staff.permissions.push(locationId);
            }

            _.save(staff, 'permissions');
        },
        remove(arr, item, type, goHome, goBack) {
            var _ = this;

            if (confirm('Are you sure you want to delete this ' + type + '?')) {
                item._status = 'attendance-archive';

                _.save(item, '_status');

                if (goHome) {
                    _.$router.push('/');
                } else if (goBack) {
                    _.$router.push('/');
                }
            }
        },
        star(location, person) {
            location.peopleIds = location.peopleIds || [];

            var _ = this,
                isStarred = _.isStarred(location, person);

            if (isStarred) {
                location.peopleIds.splice(location.peopleIds.indexOf(person.id), 1);
            } else {
                location.peopleIds.push(person.id);
            }

            _.saveLocal();

            _.ensurePersisted(location, function() {
                var args = {
                        item: {
                            type: 'location',
                            id: location.id
                        },
                        delta: {
                            attr: 'peopleIds',
                            value: person.id
                        }
                    };

                if (isStarred) {
                    args.delta.action = 'remove';
                } else {
                    args.delta.action = 'add';
                }

                _.ajax('POST', '/delta', args); // , day
            });
        },
        isStarred(location, person) {
            location.peopleIds = location.peopleIds || [];
            return location.peopleIds.indexOf(person.id) !== -1;
        },
        zeroPad(n, width, z) {
            width = width || 2;
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        },
        personName(person) {
            var splat = person.name.split(SPLIT_NAME);
            return splat.pop() + (splat.length ? (', ' + splat.join(' ')) : '');
        },
        sortByName(a, b) {
            return ('' + a.name).localeCompare(b.name, undefined, { numeric: true });
        },
        sortByPersonName(a, b) {
            var _ = this;
            return _.personName(a).localeCompare(_.personName(b), undefined, { numeric: true });
        },
        sortById(a, b) {
            return ('' + a.id).localeCompare(b.id, undefined, { numeric: true });
        },
        sortByCollection(a, b) {
            return ('' + a.location.name).localeCompare(b.location.name);
        },
        logout() {
            var _ = this;

            if (confirm('This will wipe all Attendance data off this device. All unsaved changes will be lost. Are you sure you want to log out?')) {
                _.resetPin();

                async.eachSeries(['locations', 'people', 'days', 'staff', 'unsaved'], function(collection, next) {
                    _.store.removeItem(collection, next);
                }, function() {
                    _.$router.push('/');
                    window.location.reload();
                });
            }
        },

        parseYMD(date) {
            var y = date.substr(0, 4),
                m = date.substr(5, 2) - 1,
                d = date.substr(8, 2),
                newDate = new Date(y, m, d);

            return (newDate.getFullYear() == y && newDate.getMonth() == m && newDate.getDate() == d) ? newDate : 'invalid date';
        },

        downloadTable(filename, table) {
            var str = '',
                rows = [table.header].concat(table.body).concat(table.footer),
                row;

            for (var i = 0; i < rows.length; i++) {
                row = rows[i];
                str += '"' + row.shift() + '"';

                if (row.length) {
                    str += ',' + row.join(',');
                }

                str += '\r\n';
            }

            saveAs(
                new Blob(
                    [str],
                    { type: 'text/csv;charset=utf-8' }
                ),
                filename
            );
        },

        buildCollectionReport(collection, startAt, endAt, countFunc, cellFunc) {
            var _ = this,
                date = startAt,
                uniqueIds = [],
                totalPresents = 0,
                dates = [],
                dateUniques, dateString, counter, counts, count, item, days, total, i;

            if (!date) return [];

            while (date <= endAt) {
                counts = {};
                dateUniques = [];
                total = 0;
                dateString = _.app.prepDate(date);
                days = _.app.sortedDays.filter(function(day) {
                    return day.date === dateString;
                });

                for (i = 0; i < collection.length; i++) {
                    item = collection[i];
                    counter = countFunc(days, item);
                    count = counter.count;

                    if (counter.uniqueIds && counter.uniqueIds.length) {
                        Array.prototype.push.apply(uniqueIds, counter.uniqueIds);
                        Array.prototype.push.apply(dateUniques, counter.uniqueIds);
                    }

                    counts[item.id] = typeof cellFunc === 'function' ? cellFunc(count) : count;
                    total += count;
                }

                if (total > 0) {
                    totalPresents += total;

                    dates.push({
                        raw: date,
                        counts: counts,
                        uniques: dateUniques.filter(uniques),
                        total: total
                    });
                }

                date = new Date(date);
                date.setDate( date.getDate() + 1 );
            }

            return {
                uniquePeople: uniqueIds.filter(uniques).length,
                totalPresents,
                dates
            };
        },

        reportTableData(collection, report, tableName, nameFunc, hideEmpties) {
            var _ = this,
                header = [tableName],
                body = [],
                totalRow = ['Total'],
                uniquesRow = ['Uniques'],
                count, item, cols, row, d, i;

            for (d = 0; d < report.length; d++) {
                header.push( _.app.formatDate(report[d].raw) );
                uniquesRow.push( report[d].uniques.length );
            }

            for (i = 0; i < collection.length; i++) {
                item = collection[i];
                row = [typeof nameFunc === 'function' ? nameFunc(item) : item.name];
                cols = [];

                for (d = 0; d < report.length; d++) {
                    count = report[d].counts[item.id];
                    cols.push(count);
                }

                if (!hideEmpties || cols.filter(function(col) {
                    return col !== 0;
                }).length) {
                    body.push(row.concat(cols));
                }
            }

            for (d = 0; d < report.length; d++) {
                totalRow.push(report[d].total);
            }

            var footer = [
                totalRow
            ];

            if (typeof nameFunc !== 'function') {
                footer.push(uniquesRow);
            }

            return {
                header: header,
                body: body,
                footer: footer
            };
        }
    }

    // todo: LATER, check-in vs. present
    // todo: lazy loading...
    // todo: make sure old ids get rewritten EVERYWHERE
};
</script>
